import React from 'react'
import { useState, useEffect } from 'react'
import styles from './style.module.scss'
import Avatar from '../../Avatar'
import { useTranslation } from 'react-i18next'
import orgChartHelper from 'pages/contacts/components/OrgChart/Helper'

import acceptedIcon from 'assets/images/calendar/attendee-accepted.svg'
import declinedIcon from 'assets/images/calendar/attendee-declined.svg'
import tentativeIcon from 'assets/images/calendar/attendee-tentative.svg'
import notRespondingIcon from 'assets/images/calendar/attendee-not-responding.svg'

// 순환 참조 방지를 위해 EventManager 대신 공유 유틸리티에서 import
import { isPersonaEmail, getDisplayEmailFromPersonaEmail } from 'utils/personaEmail'
import { isOrgSharedAccountEmail } from 'utils/orgSharedAccount'
import useOrgSharedOwnerName from '../../../hooks/useOrgSharedOwnerName'

export { NO_RESPONSE, ACCEPTED, DECLINED, TENTATIVE, OWNER } from './attendeeStatus'
import { ACCEPTED, DECLINED, TENTATIVE, OWNER } from './attendeeStatus'

interface UserListCellProps {
  email: string
  name?: string | null
  status: number
  nameSuffix?: string | null
  _isMobile?: boolean
}

const UserListCell = ({
  email,
  name = null,
  status,
  nameSuffix = null,
  _isMobile = false,
}: UserListCellProps) => {
  const { t } = useTranslation()

  const [inEmail, _setInEmail] = useState<string>(
    isPersonaEmail(email) ? getDisplayEmailFromPersonaEmail(email) : email,
  )
  const isOrgShared = isOrgSharedAccountEmail(inEmail)
  const ouName = useOrgSharedOwnerName(inEmail)
  // org shared 계정은 이름이 OU 목록 비동기 로드 이후에 확정되므로, useState 초기화자로 한 번만
  // 고정시키지 않고 매 렌더마다 displayName에서 계산한다 (이 state는 명시적 name prop 또는
  // 비동기 contact 조회 결과만 담당한다).
  const [inName, setInName] = useState<string | null>(name)

  useEffect(() => {
    if (isOrgShared) {
      return
    }
    if (name === null) {
      orgChartHelper.findContact(inEmail).then((user) => {
        if (user) {
          setInName(user.name)
        }
      })
    }
  }, [name, inEmail, isOrgShared])

  const displayName =
    inName || (isOrgShared ? (ouName ?? t('calendar.share.orgSharedAccount')) : email.split('@')[0])

  return (
    <div className={styles.invitee}>
      <div className={styles.container}>
        <div className={styles.avatar}>
          <Avatar name={displayName} email={inEmail} />
        </div>
        <div className={styles.infoWrapper}>
          <div className={styles.info}>
            <div className={styles.nameWrapper}>
              <div className={styles.name}>{displayName}</div>
              {nameSuffix && <span className={styles.nameSuffix}>{nameSuffix}</span>}
            </div>
            {!isOrgShared && <div className={styles.email}>{inEmail}</div>}
          </div>
          {status !== OWNER && (
            <div className={styles.status}>
              {status === ACCEPTED ? (
                <div className={styles.statusIconWrapper} title={t('meeting.status.accepted')}>
                  <img src={acceptedIcon} alt="Accepted" />
                </div>
              ) : status === DECLINED ? (
                <div className={styles.statusIconWrapper} title={t('meeting.status.declined')}>
                  <img src={declinedIcon} alt="Declined" />
                </div>
              ) : status === TENTATIVE ? (
                <div className={styles.statusIconWrapper} title={t('meeting.status.tentative')}>
                  <img src={tentativeIcon} alt="Tentative" />
                </div>
              ) : (
                <div className={styles.statusIconWrapper} title={t('meeting.status.notResponding')}>
                  <img src={notRespondingIcon} alt="Not responding" />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default UserListCell
